import React from 'react';
import moment from 'moment';
export const FormatDate = ({ date, dateFormat = 'DD.MM.YYYY HH:mm:ss.SS' }) => {
    if (!date) {
        return null;
    }
    const newDate = new Date(String(date).replace('ZZ', 'Z'));
    return React.createElement(React.Fragment, null, moment(newDate).format(dateFormat));
};
